var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.$attrs.class, _vm.btn_class],attrs:{"disabled":_vm.is_disabled},on:{"click":_vm.handleClick}},[(_vm.is_process)?_c('clip-loader',{attrs:{"loading":_vm.is_process,"size":_vm.loading_text.size,"color":_vm.loading_text.color}}):_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44acc48c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/stateButton.vue
// module id = null
// module chunks = 